import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Container, Button } from 'reactstrap';
import Loader from '../../components/Common/Loader';
import UpdateDmxDeviceForm from '../../components/Forms/UpdateDmxDeviceForm';
import DmxDevicePresetList from '../../components/Lists/DmxDevicePresetList';
import DmxDevicePresetForm from '../../components/Forms/DmxDevicePresetForm';
import { getDmxDeviceById, getDmxDevicePresets } from '../../store/actions';

class DmxDeviceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      device: this.props.location.state || null,
      presetList: null,
      presetsRequested: false,
      showPresetForm: false,
      editingPresetId: null,
    };
  }

  componentDidMount() {
    if (!this.state.device) {
      this.props.getDmxDeviceById(this.state.user, this.props.match.params.id);
    } else {
      this.maybeFetchPresets(this.state.device);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.device !== prevProps.device && this.props.device) {
      this.setState({ device: this.props.device });
      this.maybeFetchPresets(this.props.device);
    }

    if (this.props.presets !== prevProps.presets) {
      this.setState({ presetList: this.props.presets });
    }
  }

  maybeFetchPresets(device) {
    if (device && !this.state.presetsRequested) {
      this.setState({ presetsRequested: true });
      this.props.getDmxDevicePresets(this.state.user, device.id);
    }
  }

  refreshPresets() {
    this.props.getDmxDevicePresets(this.state.user, this.state.device.id);
  }

  openCreatePreset() {
    this.setState({ showPresetForm: true, editingPresetId: null });
  }

  openEditPreset(presetId) {
    this.setState({ showPresetForm: true, editingPresetId: presetId });
  }

  closePresetForm() {
    this.setState({ showPresetForm: false, editingPresetId: null });
  }

  onPresetSaved() {
    this.setState({ showPresetForm: false, editingPresetId: null });
    this.refreshPresets();
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.goBack();
  }

  renderPresetsSection() {
    const { device, presetList, showPresetForm, editingPresetId } = this.state;

    if (showPresetForm) {
      return (
        <DmxDevicePresetForm
          device={device}
          presetId={editingPresetId}
          onClose={() => this.closePresetForm()}
          onSaved={() => this.onPresetSaved()}
        />
      );
    }

    if (!presetList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }

    return (
      <DmxDevicePresetList
        device={device}
        presetList={presetList}
        onCreateNew={() => this.openCreatePreset()}
        onEdit={(presetId) => this.openEditPreset(presetId)}
        onRefresh={() => this.refreshPresets()}
      />
    );
  }

  render() {
    const { device } = this.state;
    if (!device) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <UpdateDmxDeviceForm device={device} />
          {this.renderPresetsSection()}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { device } = state.getDmxDeviceById;
  const { presets } = state.getDmxDevicePresets;
  return { device, presets };
};

export default withRouter(
  connect(mapStateToProps, { getDmxDeviceById, getDmxDevicePresets })(withNamespaces()(DmxDeviceDetails)),
);
